export default __webpack_public_path__ + "static/burrs-b40045b2acd9ec6bd90e4daae4a5d78e.png";